import React from 'react';
import {
    MetadataContainer,
    MetadataHeader,
    MetadataKey,
    MetadataKeyValue,
    MetadataValue,
    StyledMetadata,
} from './Metadata.styles';

export type MetadataProps = {
    validFrom?: string;
    validTo?: string;
    productionYear?: string;
    originalProgramTitle?: string;
    isUpcomingVOD?: boolean;
    onlyAvailableInSwedenFormatted?: string;
    nextEpisodeAvailableFormatted?: string;
};

export const Metadata = ({
    validFrom,
    validTo,
    productionYear,
    originalProgramTitle,
    isUpcomingVOD,
    onlyAvailableInSwedenFormatted,
    nextEpisodeAvailableFormatted,
}: MetadataProps) => (
    <MetadataContainer>
        <MetadataHeader>Information om {/* TODO Programtitel/avsnittstitel? */}</MetadataHeader>
        <StyledMetadata>
            {validFrom && (
                <MetadataKeyValue>
                    <MetadataKey>{isUpcomingVOD ? 'Sänds' : 'Publicerades'}</MetadataKey>
                    <MetadataValue>{validFrom}</MetadataValue>
                </MetadataKeyValue>
            )}
            {validTo && (
                <MetadataKeyValue>
                    <MetadataKey>Kan ses till</MetadataKey>
                    <MetadataValue>{validTo}</MetadataValue>
                </MetadataKeyValue>
            )}
            {Boolean(productionYear) && (
                <MetadataKeyValue>
                    <MetadataKey>Produktionsår</MetadataKey>
                    <MetadataValue>{productionYear}</MetadataValue>
                </MetadataKeyValue>
            )}
            {originalProgramTitle && (
                <MetadataKeyValue>
                    <MetadataKey>Originaltitel</MetadataKey>
                    <MetadataValue>{originalProgramTitle}</MetadataValue>
                </MetadataKeyValue>
            )}
            {onlyAvailableInSwedenFormatted && (
                <MetadataKeyValue>
                    <MetadataKey>Rättigheter</MetadataKey>
                    <MetadataValue>{onlyAvailableInSwedenFormatted}</MetadataValue>
                </MetadataKeyValue>
            )}
            {nextEpisodeAvailableFormatted && (
                <MetadataKeyValue>
                    <MetadataKey>Nästa avsnitt</MetadataKey>
                    <MetadataValue>{nextEpisodeAvailableFormatted}</MetadataValue>
                </MetadataKeyValue>
            )}
        </StyledMetadata>
    </MetadataContainer>
);

export default Metadata;
